import { tokens } from "../theme";

export const mockDataTeam = [
    {
        id: 1,
        name: "Tee King",
        email: "devteeking@gmail.com",
        post: "Software Engineer",
        phone: "(234)90-4683-2081",
        access: "admin",
    },
    {
        id: 2,
        name: "Mudashir Tunde",
        email: "mudashir.tunde.abdul@gmail.com",
        post: "Manager",
        phone: "(234)81-4344-3420",
        access: "manager",
    },
    {
        id: 3,
        name: "Temmy Tee",
        email: "temmytee@gmail.com",
        post: "General Manager",
        phone: "(234)81-4432-2381",
        access: "admin",
    },
    {
        id: 4,
        name: "Adeola Hakeem",
        email: "adeolahakeem@gmail.com",
        post: "Web App Manager",
        phone: "(234)90-2212-9082",
        access: "manager",
    },
    {
        id: 5,
        name: "Mary John",
        email: "iammaryjo@gmail.com",
        post: "Social Media Manager",
        phone: "(234)90-4683-2081",
        access: "manager",
    },
    {
        id: 6,
        name: "Elizabeth Keen",
        email: "elikeen100@gmail.com",
        post: "Directors",
        phone: "(234)80-8976-2212",
        access: "manager",
    },
    {
        id: 7,
        name: "John Mike",
        email: "callmemike@gmail.com",
        post: "Directors",
        phone: "(234)70-7654-9809",
        access: "manager",
    },
    {
        id: 8,
        name: "Coded Guy",
        email: "icodeforaliving@gmail.com",
        post: "Directors",
        phone: "(234)70-8799-5456",
        access: "admin",
    },
    {
        id: 9,
        name: "Ferrara Clifford",
        email: "ferraraclifford@gmail.com",
        post: "Directors",
        phone: "(543)124-0123",
        access: "user",
    },
    {
        id: 10,
        name: "Rossini Frances",
        email: "rossinifrances@gmail.com",
        post: "Directors",
        phone: "(222)444-5555",
        access: "user",
    },
    {
        id: 11,
        name: "Harvey Roxie",
        email: "harveyroxie@gmail.com",
        post: "Directors",
        phone: "(444)555-6239",
        access: "admin",
    },
];


export const mockDataUsers = [
    {
      id: 1,
      name: "Jon Snow",
      email: "jonsnow@gmail.com",
      status: "Verified",
      subscribedTo: "Platinum",
      phone: "(665)121-5454",
      address: "0912 Won Street, Alabama, SY 10001",
      city: "New York",
      zipCode: "10001",
      userID: "GTMPM123512",
    },
    {
      id: 2,
      name: "Cersei Lannister",
      email: "cerseilannister@gmail.com",
      status: "Unverified",
      subscribedTo: "None",
      phone: "(421)314-2288",
      address: "1234 Main Street, New York, NY 10001",
      city: "New York",
      zipCode: "13151",
      userID: "GTMPM123512",
    },
    {
      id: 3,
      name: "Jaime Lannister",
      email: "jaimelannister@gmail.com",
      status: "Verified",
      subscribedTo: "Premium",
      phone: "(422)982-6739",
      address: "3333 Want Blvd, Estanza, NAY 42125",
      city: "New York",
      zipCode: "87281",
      userID: "GTMPM413251",
    },
    {
      id: 4,
      name: "Anya Stark",
      email: "anyastark@gmail.com",
      status: "Unverified",
      subscribedTo: "None",
      phone: "(921)425-6742",
      address: "1514 Main Street, New York, NY 22298",
      city: "New York",
      zipCode: "15551",
      userID: "GTMPM123512",
    },
    {
      id: 5,
      name: "Daenerys Targaryen",
      email: "daenerystargaryen@gmail.com",
      status: "Verified",
      subscribedTo: "Premium",
      phone: "(421)445-1189",
      address: "11122 Welping Ave, Tenting, CD 21321",
      city: "Tenting",
      zipCode: "14215",
      userID: "GTMPM123512",
    },
    {
      id: 6,
      name: "Ever Melisandre",
      email: "evermelisandre@gmail.com",
      status: "Unverified",
      subscribedTo: "None",
      phone: "(232)545-6483",
      address: "1234 Canvile Street, Esvazark, NY 10001",
      city: "Esvazark",
      zipCode: "10001",
      userID: "GTMPM123512",
    },
    {
      id: 7,
      name: "Ferrara Clifford",
      email: "ferraraclifford@gmail.com",
      status: "Verified",
      subscribedTo: "Premium",
      phone: "(543)124-0123",
      address: "22215 Super Street, Everting, ZO 515234",
      city: "Evertin",
      zipCode: "51523",
      userID: "GTMPM123512",
    },
    {
      id: 8,
      name: "Rossini Frances",
      email: "rossinifrances@gmail.com",
      status: "Verified",
      subscribedTo: "Premium",
      phone: "(222)444-5555",
      address: "4123 Ever Blvd, Wentington, AD 142213",
      city: "Esteras",
      zipCode: "44215",
      userID: "GTMPM512315",
    },
    {
      id: 9,
      name: "Harvey Roxie",
      email: "harveyroxie@gmail.com",
      status: "Verified",
      subscribedTo: "Platinum",
      phone: "(444)555-6239",
      address: "51234 Avery Street, Cantory, ND 212412",
      city: "Colunza",
      zipCode: "111234",
      userID: "GTMPM928397",
    },
    {
      id: 10,
      name: "Enteri Redack",
      email: "enteriredack@gmail.com",
      status: "Verified",
      subscribedTo: "Premium",
      phone: "(222)444-5555",
      address: "4123 Easer Blvd, Wentington, AD 142213",
      city: "Esteras",
      zipCode: "44215",
      userID: "GTMPM533215",
    },
    {
      id: 11,
      name: "Steve Goodman",
      email: "stevegoodmane@gmail.com",
      status: "Verified",
      subscribedTo: "Premium",
      phone: "(444)555-6239",
      address: "51234 Fiveton Street, CunFory, ND 212412",
      city: "Colunza",
      zipCode: "1234",
      userID: "GTMPM92197",
    },
];
  
export const mockDataUserTransactions = [
    {
      id: 1,
      transactionID: "TRX1234dFS",
      name: "Jon Snow",
      email: "jonsnow@gmail.com",
      amount: "140,000,501.00",
      phone: "(665)121-5454",
      date: "03/12/2022",
    },
    {
      id: 2,
      transactionID: "TRX2347dFS",
      name: "Cersei Lannister",
      email: "cerseilannister@gmail.com",
      amount: "130,500,111.00",
      phone: "(421)314-2288",
      date: "06/15/2021",
    },
    {
      id: 3,
      transactionID: "TRX8765dFS",
      name: "Jaime Lannister",
      email: "jaimelannister@gmail.com",
      amount: "310,350,301.00",
      phone: "(422)982-6739",
      date: "05/02/2022",
    },
    {
      id: 4,
      transactionID: "TRX5532dFS",
      name: "Anya Stark",
      email: "anyastark@gmail.com",
      amount: "100,000,501.00",
      phone: "(921)425-6742",
      date: "03/21/2022",
    },
    {
      id: 5,
      transactionID: "TRX7809dFS",
      name: "Daenerys Targaryen",
      email: "daenerystargaryen@gmail.com",
      amount: "150,000,501.00",
      phone: "(421)445-1189",
      date: "01/12/2021",
    },
    {
      id: 6,
      transactionID: "TRX9094dFS",
      name: "Ever Melisandre",
      email: "evermelisandre@gmail.com",
      amount: "210,650,501.00",
      phone: "(232)545-6483",
      date: "11/02/2022",
    },
    {
      id: 7,
      transactionID: "TRX1112dFS",
      name: "Ferrara Clifford",
      email: "ferraraclifford@gmail.com",
      amount: "110,350,501.00",
      phone: "(543)124-0123",
      date: "02/11/2022",
    },
    {
      id: 8,
      transactionID: "TRX5432dFS",
      name: "Rossini Frances",
      email: "rossinifrances@gmail.com",
      amount: "210,200,501.00",
      phone: "(222)444-5555",
      date: "05/02/2021",
    },
];

export const mockDataInvestments = [
  {
    id: 1,
    investmentID: "GTMPM1234dFS",
    name: "Adeola Adeagbo",
    email: "jonsnow@gmail.com",
    amount: "140,000,501.00",
    phone: "(665)121-5454",
    startDate: "03/12/2022",
    maturityDate: "03/12/2023",
  },
  {
    id: 2,
    investmentID: "GTMPM2347dFS",
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    amount: "130,500,111.00",
    phone: "(421)314-2288",
    startDate: "06/15/2021",
    maturityDate: "06/15/2022",
  },
  {
    id: 3,
    investmentID: "GTMPM8765dFS",
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    amount: "310,350,301.00",
    phone: "(422)982-6739",
    startDate: "05/02/2022",
    maturityDate: "05/02/2023",
  },
  {
    id: 4,
    investmentID: "GTMPM5532dFS",
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    amount: "100,000,501.00",
    phone: "(921)425-6742",
    startDate: "03/21/2022",
    maturityDate: "03/21/2023",
  },
  {
    id: 5,
    investmentID: "GTMPM7809dFS",
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    amount: "150,000,501.00",
    phone: "(421)445-1189",
    startDate: "01/12/2021",
    maturityDate: "01/12/2022",
  },
  {
    id: 6,
    investmentID: "GTMPM9094dFS",
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    amount: "210,650,501.00",
    phone: "(232)545-6483",
    startDate: "11/02/2022",
    maturityDate: "11/02/2023",
  },
  {
    id: 7,
    investmentID: "GTMPM1112dFS",
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    amount: "110,350,501.00",
    phone: "(543)124-0123",
    startDate: "02/11/2022",
    maturityDate: "02/11/2023",
  },
  {
    id: 8,
    investmentID: "GTMPM5432dFS",
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    amount: "210,200,501.00",
    phone: "(222)444-5555",
    startDate: "05/02/2021",
    maturityDate: "05/02/2022",
  },
];

export const mockPendingWithdrawals = [
  {
    txId: "01e4dsa",
    email: "johndoe@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Pending"
  },
  {
    txId: "0315dsaa",
    email: "jackdower@gmail.com",
    date: "2022-04-01",
    amount: "133.45",
    status: "Pending"
  },
  {
    txId: "01e4dsa",
    email: "aberdohnny@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Pending"
  },
  {
    txId: "51034szv",
    email: "goodmanave@gmail.com",
    date: "2022-11-05",
    amount: "200.95",
    status: "Pending"
  },
  {
    txId: "0a123sb",
    email: "stevebower@gmail.com",
    date: "2022-11-02",
    amount: "13.55",
    status: "Pending"
  },
  {
    txId: "01e4dss",
    email: "aberdohnny@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Pending"
  },
  {
    txId: "120s51a",
    email: "wootzifer@gmail.com",
    date: "2019-04-15",
    amount: "24.20",
    status: "Pending"
  },
  {
    txId: "0315dshga",
    email: "jackdower@gmail.com",
    date: "2022-04-01",
    amount: "133.45",
    status: "Pending"
  },
];

export const mockCompletedWithdrawals = [
  {
    txId: "01e4dsa",
    email: "johndoe@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Completed"
  },
  {
    txId: "0315dsak",
    email: "jackdower@gmail.com",
    date: "2022-04-01",
    amount: "133.45",
    status: "Completed"
  },
  {
    txId: "01e4dsp",
    email: "aberdohnny@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Completed"
  },
  {
    txId: "51034szv",
    email: "goodmanave@gmail.com",
    date: "2022-11-05",
    amount: "200.95",
    status: "Completed"
  },
  {
    txId: "0a123sb",
    email: "stevebower@gmail.com",
    date: "2022-11-02",
    amount: "13.55",
    status: "Completed"
  },
  {
    txId: "01e4dss",
    email: "aberdohnny@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Completed"
  },
  {
    txId: "120s51a",
    email: "wootzifer@gmail.com",
    date: "2019-04-15",
    amount: "24.20",
    status: "Completed"
  },
  {
    txId: "0315dshh",
    email: "jackdower@gmail.com",
    date: "2022-04-01",
    amount: "133.45",
    status: "Completed"
  },
];

export const mockDeclinedWithdrawals = [
  {
    txId: "01e4dba",
    email: "johndoe@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Declined"
  },
  {
    txId: "0315dskf",
    email: "jackdower@gmail.com",
    date: "2022-04-01",
    amount: "133.45",
    status: "Declined"
  },
  {
    txId: "01e4dsa",
    email: "aberdohnny@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Declined"
  },
  {
    txId: "51034szv",
    email: "goodmanave@gmail.com",
    date: "2022-11-05",
    amount: "200.95",
    status: "Declined"
  },
  {
    txId: "0a123sr",
    email: "stevebower@gmail.com",
    date: "2022-11-02",
    amount: "13.55",
    status: "Declined"
  },
  {
    txId: "01e4gsa",
    email: "aberdohnny@gmail.com",
    date: "2021-09-01",
    amount: "43.95",
    status: "Declined"
  },
  {
    txId: "120s51x",
    email: "wootzifer@gmail.com",
    date: "2019-04-15",
    amount: "24.20",
    status: "Declined"
  },
  {
    txId: "0315dsqa",
    email: "jackdower@gmail.com",
    date: "2022-04-01",
    amount: "133.45",
    status: "Declined"
  },
];

export const mockProjects = [
  {
    projectID: "01e4dwwqsa",
    projectTitle: "Zion City Estate",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Pending",
    projectCoverImage: "zion-cover.jpg",
  },
  {
    projectID: "0315dsasda",
    projectTitle: "Las Vegas City",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    projectCoverImage: "zion-cover.jpg",
  },
  {
    projectID: "01e4ddwqsa",
    projectTitle: "Palace Royal Estate",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Ongoing",
    projectCoverImage: "zion-cover.jpg",
  },
  {
    projectID: "51034sjuzv",
    projectTitle: "Duplex in Mararaba",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Pending",
    projectCoverImage: "zion-cover.jpg",
  },
  {
    projectID: "0a123iosb",
    projectTitle: "5 Bedroom Duplex, Abuja",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Ongoing",
    projectCoverImage: "zion-cover.jpg",
  },
  {
    projectID: "01e4dilpsa",
    projectTitle: "7 Bedroom Duplex, Lekki",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    projectCoverImage: "zion-cover.jpg",
  },
  {
    projectID: "120saq51a",
    projectTitle: "3 Bedroom Bungalow",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    projectCoverImage: "zion-cover.jpg",
  },
  {
    projectID: "0315ppdsaa",
    projectTitle: "2 Storey Shopping Complex",
    projectDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    projectCoverImage: "zion-cover.jpg",
  },
];

export const mockListings = [
  {
    listID: "01e4dwwqsa",
    listTitle: "Zion City Estate",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Pending",
    listCoverImage: "zion-cover.jpg",
    price: "75,000,000"
  },
  {
    listID: "0315dsasda",
    listTitle: "Las Vegas City",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    listCoverImage: "zion-cover.jpg",
    price: "220,000,000"
  },
  {
    listID: "01e4ddwqsa",
    listTitle: "Palace Royal Estate",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Ongoing",
    listCoverImage: "zion-cover.jpg",
    price: "135,500,000"
  },
  {
    listID: "51034sjuzv",
    listTitle: "Duplex in Mararaba",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Pending",
    listCoverImage: "zion-cover.jpg",
    price: "120,000,000"
  },
  {
    listID: "0a123iosb",
    listTitle: "5 Bedroom Duplex, Abuja",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Ongoing",
    listCoverImage: "zion-cover.jpg",
    price: "120,000,000"
  },
  {
    listID: "01e4dilpsa",
    listTitle: "7 Bedroom Duplex, Lekki",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    listCoverImage: "zion-cover.jpg",
    price: "120,000,000"
  },
  {
    listID: "120saq51a",
    listTitle: "3 Bedroom Bungalow",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    listCoverImage: "zion-cover.jpg",
    price: "120,000,000"
  },
  {
    listID: "0315ppdsaa",
    listTitle: "2 Storey Shopping Complex",
    listDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    listCoverImage: "zion-cover.jpg",
    price: "120,000,000"
  },
];

export const mockEventsGallery = [
  {
    eventID: "01e4dwwqsa",
    eventTitle: "Zion City Estate",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Pending",
    eventCoverImage: "zion-cover.jpg",
  },
  {
    eventID: "0315dsasda",
    eventTitle: "Las Vegas City",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    eventCoverImage: "zion-cover.jpg",
  },
  {
    eventID: "01e4ddwqsa",
    eventTitle: "Palace Royal Estate",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Ongoing",
    eventCoverImage: "zion-cover.jpg",
  },
  {
    eventID: "51034sjuzv",
    eventTitle: "Duplex in Mararaba",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Pending",
    eventCoverImage: "zion-cover.jpg",
  },
  {
    eventID: "0a123iosb",
    eventTitle: "5 Bedroom Duplex, Abuja",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Ongoing",
    eventCoverImage: "zion-cover.jpg",
  },
  {
    eventID: "01e4dilpsa",
    eventTitle: "7 Bedroom Duplex, Lekki",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    eventCoverImage: "zion-cover.jpg",
  },
  {
    eventID: "120saq51a",
    eventTitle: "3 Bedroom Bungalow",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    eventCoverImage: "zion-cover.jpg",
  },
  {
    eventID: "0315ppdsaa",
    eventTitle: "2 Storey Shopping Complex",
    eventDetails: "This is a luxurious beachfront property of 3 & 4 bedrooms Duplex with BQ in Okun-Ajah, Off Abraham Adesanya, Ogombo Road, Lagos. The project is meant to be completed in May ending, 2023. features: 24hrs Power Supply, Good road network, 2hrs security, bar section, Car Park, cctv camera, car park etc.",
    status: "Completed",
    eventCoverImage: "zion-cover.jpg",
  },
];

export const mockFAQ = [
  {
    id: 1,
    question: "An Important Questions",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat ipsam reprehenderit quis maxime, sed ullam unde autem fuga tempore? Aut atque laborum eligendi vitae optio qui magni at saepe est."
  },
  {
    id: 2,
    question: "Another Important Questions",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat ipsam reprehenderit quis maxime, sed ullam unde autem fuga tempore? Aut atque laborum eligendi vitae optio qui magni at saepe est."
  },
  {
    id: 3,
    question: "Third Important Questions",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat ipsam reprehenderit quis maxime, sed ullam unde autem fuga tempore? Aut atque laborum eligendi vitae optio qui magni at saepe est."
  },
  {
    id: 4,
    question: "Last Important Questions",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat ipsam reprehenderit quis maxime, sed ullam unde autem fuga tempore? Aut atque laborum eligendi vitae optio qui magni at saepe est."
  }
]



  
export const mockTransactions = [
    {
      txId: "01e4dsa",
      user: "johndoe",
      date: "2021-09-01",
      cost: "43.95",
    },
    {
      txId: "0315dsaa",
      user: "jackdower",
      date: "2022-04-01",
      cost: "133.45",
    },
    {
      txId: "01e4dsa",
      user: "aberdohnny",
      date: "2021-09-01",
      cost: "43.95",
    },
    {
      txId: "51034szv",
      user: "goodmanave",
      date: "2022-11-05",
      cost: "200.95",
    },
    {
      txId: "0a123sb",
      user: "stevebower",
      date: "2022-11-02",
      cost: "13.55",
    },
    {
      txId: "01e4dsa",
      user: "aberdohnny",
      date: "2021-09-01",
      cost: "43.95",
    },
    {
      txId: "120s51a",
      user: "wootzifer",
      date: "2019-04-15",
      cost: "24.20",
    },
    {
      txId: "0315dsaa",
      user: "jackdower",
      date: "2022-04-01",
      cost: "133.45",
    },
];

export const mockBarData = [
    {
      country: "AD",
      "hot dog": 137,
      "hot dogColor": "hsl(229, 70%, 50%)",
      burger: 96,
      burgerColor: "hsl(296, 70%, 50%)",
      kebab: 72,
      kebabColor: "hsl(97, 70%, 50%)",
      donut: 140,
      donutColor: "hsl(340, 70%, 50%)",
    },
    {
      country: "AE",
      "hot dog": 55,
      "hot dogColor": "hsl(307, 70%, 50%)",
      burger: 28,
      burgerColor: "hsl(111, 70%, 50%)",
      kebab: 58,
      kebabColor: "hsl(273, 70%, 50%)",
      donut: 29,
      donutColor: "hsl(275, 70%, 50%)",
    },
    {
      country: "AF",
      "hot dog": 109,
      "hot dogColor": "hsl(72, 70%, 50%)",
      burger: 23,
      burgerColor: "hsl(96, 70%, 50%)",
      kebab: 34,
      kebabColor: "hsl(106, 70%, 50%)",
      donut: 152,
      donutColor: "hsl(256, 70%, 50%)",
    },
    {
      country: "AG",
      "hot dog": 133,
      "hot dogColor": "hsl(257, 70%, 50%)",
      burger: 52,
      burgerColor: "hsl(326, 70%, 50%)",
      kebab: 43,
      kebabColor: "hsl(110, 70%, 50%)",
      donut: 83,
      donutColor: "hsl(9, 70%, 50%)",
    },
    {
      country: "AI",
      "hot dog": 81,
      "hot dogColor": "hsl(190, 70%, 50%)",
      burger: 80,
      burgerColor: "hsl(325, 70%, 50%)",
      kebab: 112,
      kebabColor: "hsl(54, 70%, 50%)",
      donut: 35,
      donutColor: "hsl(285, 70%, 50%)",
    },
    {
      country: "AL",
      "hot dog": 66,
      "hot dogColor": "hsl(208, 70%, 50%)",
      burger: 111,
      burgerColor: "hsl(334, 70%, 50%)",
      kebab: 167,
      kebabColor: "hsl(182, 70%, 50%)",
      donut: 18,
      donutColor: "hsl(76, 70%, 50%)",
    },
    {
      country: "AM",
      "hot dog": 80,
      "hot dogColor": "hsl(87, 70%, 50%)",
      burger: 47,
      burgerColor: "hsl(141, 70%, 50%)",
      kebab: 158,
      kebabColor: "hsl(224, 70%, 50%)",
      donut: 49,
      donutColor: "hsl(274, 70%, 50%)",
    },
];
  
export const mockPieData = [
    {
      id: "hack",
      label: "hack",
      value: 239,
      color: "hsl(104, 70%, 50%)",
    },
    {
      id: "make",
      label: "make",
      value: 170,
      color: "hsl(162, 70%, 50%)",
    },
    {
      id: "go",
      label: "go",
      value: 322,
      color: "hsl(291, 70%, 50%)",
    },
    {
      id: "lisp",
      label: "lisp",
      value: 503,
      color: "hsl(229, 70%, 50%)",
    },
    {
      id: "scala",
      label: "scala",
      value: 584,
      color: "hsl(344, 70%, 50%)",
    },
];
  
export const mockLineData = [
    {
      id: "Standard",
      color: tokens("dark").greenAccent[500],
      data: [
        {
          x: "JAN",
          y: 101,
        },
        {
          x: "FEB",
          y: 75,
        },
        {
          x: "MAR",
          y: 36,
        },
        {
          x: "APR",
          y: 216,
        },
        {
          x: "MAY",
          y: 35,
        },
        {
          x: "JUL",
          y: 236,
        },
        {
          x: "AUG",
          y: 88,
        },
        {
          x: "SEP",
          y: 232,
        },
        {
          x: "OCT",
          y: 281,
        },
        {
          x: "NOV",
          y: 1,
        },
        {
          x: "DEC",
          y: 35,
        },
        {
          x: "others",
          y: 14,
        },
      ],
    },
    {
      id: "Premium",
      color: tokens("dark").blueAccent[300],
      data: [
        {
          x: "JAN",
          y: 212,
        },
        {
          x: "FEB",
          y: 190,
        },
        {
          x: "MAR",
          y: 270,
        },
        {
          x: "APR",
          y: 9,
        },
        {
          x: "MAY",
          y: 75,
        },
        {
          x: "JUL",
          y: 175,
        },
        {
          x: "AUG",
          y: 33,
        },
        {
          x: "SEP",
          y: 189,
        },
        {
          x: "OCT",
          y: 97,
        },
        {
          x: "NOV",
          y: 87,
        },
        {
          x: "DEC",
          y: 299,
        },
        {
          x: "others",
          y: 251,
        },
      ],
    },
    {
      id: "Gold",
      color: tokens("dark").redAccent[200],
      data: [
        {
          x: "JAN",
          y: 191,
        },
        {
          x: "FEB",
          y: 136,
        },
        {
          x: "MAR",
          y: 91,
        },
        {
          x: "APR",
          y: 190,
        },
        {
          x: "MAY",
          y: 211,
        },
        {
          x: "JUL",
          y: 152,
        },
        {
          x: "AUG",
          y: 189,
        },
        {
          x: "SEP",
          y: 152,
        },
        {
          x: "OCT",
          y: 8,
        },
        {
          x: "NOV",
          y: 197,
        },
        {
          x: "DEC",
          y: 107,
        },
        {
          x: "others",
          y: 170,
        },
      ],
    },
  ];
  
export const mockGeographyData = [
    {
      id: "AFG",
      value: 520600,
    },
    {
      id: "AGO",
      value: 949905,
    },
    {
      id: "ALB",
      value: 329910,
    },
    {
      id: "ARE",
      value: 675484,
    },
    {
      id: "ARG",
      value: 432239,
    },
    {
      id: "ARM",
      value: 288305,
    },
    {
      id: "ATA",
      value: 415648,
    },
    {
      id: "ATF",
      value: 665159,
    },
    {
      id: "AUT",
      value: 798526,
    },
    {
      id: "AZE",
      value: 481678,
    },
    {
      id: "BDI",
      value: 496457,
    },
    {
      id: "BEL",
      value: 252276,
    },
    {
      id: "BEN",
      value: 440315,
    },
    {
      id: "BFA",
      value: 343752,
    },
    {
      id: "BGD",
      value: 920203,
    },
    {
      id: "BGR",
      value: 261196,
    },
    {
      id: "BHS",
      value: 421551,
    },
    {
      id: "BIH",
      value: 974745,
    },
    {
      id: "BLR",
      value: 349288,
    },
    {
      id: "BLZ",
      value: 305983,
    },
    {
      id: "BOL",
      value: 430840,
    },
    {
      id: "BRN",
      value: 345666,
    },
    {
      id: "BTN",
      value: 649678,
    },
    {
      id: "BWA",
      value: 319392,
    },
    {
      id: "CAF",
      value: 722549,
    },
    {
      id: "CAN",
      value: 332843,
    },
    {
      id: "CHE",
      value: 122159,
    },
    {
      id: "CHL",
      value: 811736,
    },
    {
      id: "CHN",
      value: 593604,
    },
    {
      id: "CIV",
      value: 143219,
    },
    {
      id: "CMR",
      value: 630627,
    },
    {
      id: "COG",
      value: 498556,
    },
    {
      id: "COL",
      value: 660527,
    },
    {
      id: "CRI",
      value: 60262,
    },
    {
      id: "CUB",
      value: 177870,
    },
    {
      id: "-99",
      value: 463208,
    },
    {
      id: "CYP",
      value: 945909,
    },
    {
      id: "CZE",
      value: 500109,
    },
    {
      id: "DEU",
      value: 63345,
    },
    {
      id: "DJI",
      value: 634523,
    },
    {
      id: "DNK",
      value: 731068,
    },
    {
      id: "DOM",
      value: 262538,
    },
    {
      id: "DZA",
      value: 760695,
    },
    {
      id: "ECU",
      value: 301263,
    },
    {
      id: "EGY",
      value: 148475,
    },
    {
      id: "ERI",
      value: 939504,
    },
    {
      id: "ESP",
      value: 706050,
    },
    {
      id: "EST",
      value: 977015,
    },
    {
      id: "ETH",
      value: 461734,
    },
    {
      id: "FIN",
      value: 22800,
    },
    {
      id: "FJI",
      value: 18985,
    },
    {
      id: "FLK",
      value: 64986,
    },
    {
      id: "FRA",
      value: 447457,
    },
    {
      id: "GAB",
      value: 669675,
    },
    {
      id: "GBR",
      value: 757120,
    },
    {
      id: "GEO",
      value: 158702,
    },
    {
      id: "GHA",
      value: 893180,
    },
    {
      id: "GIN",
      value: 877288,
    },
    {
      id: "GMB",
      value: 724530,
    },
    {
      id: "GNB",
      value: 387753,
    },
    {
      id: "GNQ",
      value: 706118,
    },
    {
      id: "GRC",
      value: 377796,
    },
    {
      id: "GTM",
      value: 66890,
    },
    {
      id: "GUY",
      value: 719300,
    },
    {
      id: "HND",
      value: 739590,
    },
    {
      id: "HRV",
      value: 929467,
    },
    {
      id: "HTI",
      value: 538961,
    },
    {
      id: "HUN",
      value: 146095,
    },
    {
      id: "IDN",
      value: 490681,
    },
    {
      id: "IND",
      value: 549818,
    },
    {
      id: "IRL",
      value: 630163,
    },
    {
      id: "IRN",
      value: 596921,
    },
    {
      id: "IRQ",
      value: 767023,
    },
    {
      id: "ISL",
      value: 478682,
    },
    {
      id: "ISR",
      value: 963688,
    },
    {
      id: "ITA",
      value: 393089,
    },
    {
      id: "JAM",
      value: 83173,
    },
    {
      id: "JOR",
      value: 52005,
    },
    {
      id: "JPN",
      value: 199174,
    },
    {
      id: "KAZ",
      value: 181424,
    },
    {
      id: "KEN",
      value: 60946,
    },
    {
      id: "KGZ",
      value: 432478,
    },
    {
      id: "KHM",
      value: 254461,
    },
    {
      id: "OSA",
      value: 942447,
    },
    {
      id: "KWT",
      value: 414413,
    },
    {
      id: "LAO",
      value: 448339,
    },
    {
      id: "LBN",
      value: 620090,
    },
    {
      id: "LBR",
      value: 435950,
    },
    {
      id: "LBY",
      value: 75091,
    },
    {
      id: "LKA",
      value: 595124,
    },
    {
      id: "LSO",
      value: 483524,
    },
    {
      id: "LTU",
      value: 867357,
    },
    {
      id: "LUX",
      value: 689172,
    },
    {
      id: "LVA",
      value: 742980,
    },
    {
      id: "MAR",
      value: 236538,
    },
    {
      id: "MDA",
      value: 926836,
    },
    {
      id: "MDG",
      value: 840840,
    },
    {
      id: "MEX",
      value: 353910,
    },
    {
      id: "MKD",
      value: 505842,
    },
    {
      id: "MLI",
      value: 286082,
    },
    {
      id: "MMR",
      value: 915544,
    },
    {
      id: "MNE",
      value: 609500,
    },
    {
      id: "MNG",
      value: 410428,
    },
    {
      id: "MOZ",
      value: 32868,
    },
    {
      id: "MRT",
      value: 375671,
    },
    {
      id: "MWI",
      value: 591935,
    },
    {
      id: "MYS",
      value: 991644,
    },
    {
      id: "NAM",
      value: 701897,
    },
    {
      id: "NCL",
      value: 144098,
    },
    {
      id: "NER",
      value: 312944,
    },
    {
      id: "NGA",
      value: 862877,
    },
    {
      id: "NIC",
      value: 90831,
    },
    {
      id: "NLD",
      value: 281879,
    },
    {
      id: "NOR",
      value: 224537,
    },
    {
      id: "NPL",
      value: 322331,
    },
    {
      id: "NZL",
      value: 86615,
    },
    {
      id: "OMN",
      value: 707881,
    },
    {
      id: "PAK",
      value: 158577,
    },
    {
      id: "PAN",
      value: 738579,
    },
    {
      id: "PER",
      value: 248751,
    },
    {
      id: "PHL",
      value: 557292,
    },
    {
      id: "PNG",
      value: 516874,
    },
    {
      id: "POL",
      value: 682137,
    },
    {
      id: "PRI",
      value: 957399,
    },
    {
      id: "PRT",
      value: 846430,
    },
    {
      id: "PRY",
      value: 720555,
    },
    {
      id: "QAT",
      value: 478726,
    },
    {
      id: "ROU",
      value: 259318,
    },
    {
      id: "RUS",
      value: 268735,
    },
    {
      id: "RWA",
      value: 136781,
    },
    {
      id: "ESH",
      value: 151957,
    },
    {
      id: "SAU",
      value: 111821,
    },
    {
      id: "SDN",
      value: 927112,
    },
    {
      id: "SDS",
      value: 966473,
    },
    {
      id: "SEN",
      value: 158085,
    },
    {
      id: "SLB",
      value: 178389,
    },
    {
      id: "SLE",
      value: 528433,
    },
    {
      id: "SLV",
      value: 353467,
    },
    {
      id: "ABV",
      value: 251,
    },
    {
      id: "SOM",
      value: 445243,
    },
    {
      id: "SRB",
      value: 202402,
    },
    {
      id: "SUR",
      value: 972121,
    },
    {
      id: "SVK",
      value: 319923,
    },
    {
      id: "SVN",
      value: 728766,
    },
    {
      id: "SWZ",
      value: 379669,
    },
    {
      id: "SYR",
      value: 16221,
    },
    {
      id: "TCD",
      value: 101273,
    },
    {
      id: "TGO",
      value: 498411,
    },
    {
      id: "THA",
      value: 506906,
    },
    {
      id: "TJK",
      value: 613093,
    },
    {
      id: "TKM",
      value: 327016,
    },
    {
      id: "TLS",
      value: 607972,
    },
    {
      id: "TTO",
      value: 936365,
    },
    {
      id: "TUN",
      value: 898416,
    },
    {
      id: "TUR",
      value: 237783,
    },
    {
      id: "TWN",
      value: 878213,
    },
    {
      id: "TZA",
      value: 442174,
    },
    {
      id: "UGA",
      value: 720710,
    },
    {
      id: "UKR",
      value: 74172,
    },
    {
      id: "URY",
      value: 753177,
    },
    {
      id: "USA",
      value: 658725,
    },
    {
      id: "UZB",
      value: 550313,
    },
    {
      id: "VEN",
      value: 707492,
    },
    {
      id: "VNM",
      value: 538907,
    },
    {
      id: "VUT",
      value: 650646,
    },
    {
      id: "PSE",
      value: 476078,
    },
    {
      id: "YEM",
      value: 957751,
    },
    {
      id: "ZAF",
      value: 836949,
    },
    {
      id: "ZMB",
      value: 714503,
    },
    {
      id: "ZWE",
      value: 405217,
    },
    {
      id: "KOR",
      value: 171135,
    },
];